
import { Link } from 'react-router-dom';

export default function BurnoutPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-red-50 via-rose-50 to-orange-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-red-600 via-rose-600 to-orange-600 text-white py-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto">
            <Link to="/motivation" className="inline-flex items-center text-white/80 hover:text-white mb-6 transition-colors">
              <i className="ri-arrow-left-line mr-2"></i>
              動機付け一覧に戻る
            </Link>
            <div className="inline-flex items-center justify-center w-16 h-16 bg-white/20 backdrop-blur-sm rounded-xl mb-6">
              <i className="ri-fire-line text-4xl"></i>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">バーンアウト理論</h1>
            <p className="text-xl text-white/90">Maslach Burnout Theory</p>
          </div>
        </div>
      </section>

      {/* Core Message */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-red-500 to-rose-500 rounded-2xl shadow-2xl p-8 md:p-12 text-white text-center">
              <h2 className="text-3xl font-bold mb-4">情緒的消耗・脱人格化・個人的達成感の低下の3要素で段階的に進行</h2>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto space-y-12">
            {/* バーンアウトの3要素 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-red-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-red-500 to-rose-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-focus-3-line text-xl text-white"></i>
                </div>
                バーンアウトの3要素
              </h2>
              <div className="space-y-6">
                <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-xl p-6 border border-red-200">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-gradient-to-br from-red-500 to-red-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <span className="text-white font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">情緒的消耗</h3>
                      <p className="text-sm text-gray-600 mb-2">Emotional Exhaustion</p>
                      <p className="text-gray-700 text-sm leading-relaxed">
                        感情的なエネルギーが枯渇し、疲弊感が続く状態。「もう何もしたくない」という感覚。
                      </p>
                      <div className="mt-3 p-2 bg-red-100 rounded">
                        <p className="text-xs text-red-700">サイン：慢性的な疲労感、朝起きるのがつらい、休んでも回復しない</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-rose-50 to-orange-50 rounded-xl p-6 border border-rose-200">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-gradient-to-br from-rose-500 to-rose-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <span className="text-white font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">脱人格化</h3>
                      <p className="text-sm text-gray-600 mb-2">Depersonalization</p>
                      <p className="text-gray-700 text-sm leading-relaxed">
                        患者や同僚に対して冷淡・無関心になる状態。人を「モノ」のように扱ってしまう。
                      </p>
                      <div className="mt-3 p-2 bg-rose-100 rounded">
                        <p className="text-xs text-rose-700">サイン：患者への共感が薄れる、同僚との関わりを避ける、皮肉っぽくなる</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl p-6 border border-orange-200">
                  <div className="flex items-start">
                    <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                      <span className="text-white font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">個人的達成感の低下</h3>
                      <p className="text-sm text-gray-600 mb-2">Reduced Personal Accomplishment</p>
                      <p className="text-gray-700 text-sm leading-relaxed">
                        自分の仕事に意味を感じられなくなり、「自分は役に立っていない」と感じる状態。
                      </p>
                      <div className="mt-3 p-2 bg-orange-100 rounded">
                        <p className="text-xs text-orange-700">サイン：自己効力感の低下、「何をやっても無駄」という感覚、離職願望</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 薬局運営への活用 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-red-100">
              <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                <div className="w-10 h-10 bg-gradient-to-br from-rose-500 to-red-500 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-hospital-line text-xl text-white"></i>
                </div>
                薬局運営への活用
              </h2>
              <div className="space-y-6">
                <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-xl p-6 border border-red-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-alarm-warning-line text-red-600 mr-2"></i>
                    早期サイン検知
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    バーンアウトは段階的に進行します。早期のサインを見逃さないことが重要です。
                  </p>
                  <div className="grid md:grid-cols-3 gap-4">
                    <div className="bg-white rounded-lg p-4 border border-red-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm text-center">初期</h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・疲れが取れない</li>
                        <li>・イライラしやすい</li>
                        <li>・集中力の低下</li>
                      </ul>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-rose-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm text-center">中期</h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・患者への関心低下</li>
                        <li>・同僚との関わり回避</li>
                        <li>・ミスの増加</li>
                      </ul>
                    </div>
                    <div className="bg-white rounded-lg p-4 border border-orange-100">
                      <h4 className="font-bold text-gray-900 mb-2 text-sm text-center">後期</h4>
                      <ul className="text-xs text-gray-600 space-y-1">
                        <li>・無力感・絶望感</li>
                        <li>・身体症状の出現</li>
                        <li>・離職願望</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="bg-gradient-to-br from-rose-50 to-orange-50 rounded-xl p-6 border border-rose-200">
                  <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center">
                    <i className="ri-heart-pulse-line text-rose-600 mr-2"></i>
                    「休ませる」ではなく「回復させる設計」
                  </h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    バーンアウトの対策は「休ませる」だけでは不十分です。<strong className="text-rose-600">回復できる環境</strong>を設計することが重要です。
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start p-3 bg-white rounded-lg border border-rose-100">
                      <i className="ri-checkbox-circle-fill text-green-500 mr-3 mt-0.5"></i>
                      <div>
                        <span className="text-gray-700 text-sm font-semibold">業務量の調整</span>
                        <p className="text-xs text-gray-500">一時的な負荷軽減、役割の見直し</p>
                      </div>
                    </div>
                    <div className="flex items-start p-3 bg-white rounded-lg border border-rose-100">
                      <i className="ri-checkbox-circle-fill text-green-500 mr-3 mt-0.5"></i>
                      <div>
                        <span className="text-gray-700 text-sm font-semibold">自律性の回復</span>
                        <p className="text-xs text-gray-500">自分で決められる範囲を増やす</p>
                      </div>
                    </div>
                    <div className="flex items-start p-3 bg-white rounded-lg border border-rose-100">
                      <i className="ri-checkbox-circle-fill text-green-500 mr-3 mt-0.5"></i>
                      <div>
                        <span className="text-gray-700 text-sm font-semibold">達成感の回収</span>
                        <p className="text-xs text-gray-500">小さな成功体験、感謝の言葉</p>
                      </div>
                    </div>
                    <div className="flex items-start p-3 bg-white rounded-lg border border-rose-100">
                      <i className="ri-checkbox-circle-fill text-green-500 mr-3 mt-0.5"></i>
                      <div>
                        <span className="text-gray-700 text-sm font-semibold">関係性の修復</span>
                        <p className="text-xs text-gray-500">チームのサポート、孤立させない</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 明日の一手 */}
            <div className="bg-gradient-to-br from-red-600 via-rose-600 to-orange-600 rounded-2xl shadow-2xl p-8 text-white">
              <h2 className="text-2xl font-bold mb-4 flex items-center">
                <i className="ri-calendar-check-line text-3xl mr-3"></i>
                明日の一手
              </h2>
              <p className="text-lg text-white/90 leading-relaxed mb-6">
                職員のバーンアウトの兆候がないか、観察してみましょう。
              </p>
              <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6">
                <p className="text-white font-semibold mb-2">具体的なアクション：</p>
                <p className="text-white/90 leading-relaxed">
                  「最近疲れていませんか？」「仕事で困っていることはありますか？」と声をかけ、早期のサインを見逃さないようにする。
                </p>
              </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-between items-center pt-8 border-t border-gray-200">
              <Link to="/motivation/equity" className="flex items-center text-red-600 hover:text-red-700 font-semibold transition-colors">
                <i className="ri-arrow-left-line mr-2"></i>
                公平性理論
              </Link>
              <Link to="/motivation/emotional-labor" className="flex items-center text-red-600 hover:text-red-700 font-semibold transition-colors">
                感情労働
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
